











 










const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GitLabProviderRow_integrationProvider",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serverBaseUrl",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EditGitLabProviderDialog_integrationProvider"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RemoveIntegrationProviderDialog_integrationProvider"
    }
  ],
  "type": "IntegrationProviderOAuth2",
  "abstractKey": null
};

(node ).hash = "d2be2514938dcd397c475e7bb2ef7579";

export default node;
